import { Typo } from "../Typo";

type WelcomeDisplayNameProps = {
  greeting: string;
};

export const WelcomeDisplayName = ({ greeting }: WelcomeDisplayNameProps) => (
  <div className="flex flex-col flex-wrap gap-1 lg:flex-row lg:items-center lg:gap-4">
    <Typo element="h1" smType="display3XL" lgType="display5XL">
      {greeting}
    </Typo>
  </div>
);
